module.exports = __webpack_public_path__ + "img/index_types.ee2a65ae.png";